export default [
  {
    id: 1,
    title: "Reciept Format",
    field: [
      {
        id: 1,
        name: "Tax Invoice (ABB) Format",
      },
      {
        id: 2,
        name: "Tax Invoice Format",
      },
    ],
  },
  {
    id: 2,
    title: "Transfer Format",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
  {
    id: 3,
    title: "Repair Format",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
  {
    id: 4,
    title: "Consignment Format",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
  {
    id: 5,
    title: "Purchase Order Format",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
  {
    id: 6,
    title: "Buy-BACK Format",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
  {
    id: 7,
    title: "DEPOSIT FORMAT",
    field: [
      {
        id: 1,
        name: "",
      },
    ],
  },
];
